import FormTemplateList from "./pages/ListPage.vue";
import FormTemplateDetail from "./pages/FormPage.vue";
import FormTemplateIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/form_template",
    component: FormTemplateIndex,
    redirect: "/form_template/list",
    name: "form_template",
    children: [
      {
        path: "list",
        component: FormTemplateList,
        name: "form_template.list",
      },
      {
        path: "create",
        component: FormTemplateDetail,
        name: "form_template.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: FormTemplateDetail,
        name: "form_template.edit",
        props: { create: false },
      },
    ],
  },
];
